import { render, staticRenderFns } from "./DocumentDetail.vue?vue&type=template&id=219a88f5&scoped=true&"
import script from "./DocumentDetail.vue?vue&type=script&lang=js&"
export * from "./DocumentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a88f5",
  null
  
)

export default component.exports